import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=a5993552&scoped=true&"
import script from "./ProfileEdit.vue?vue&type=script&lang=tsx&"
export * from "./ProfileEdit.vue?vue&type=script&lang=tsx&"
import style0 from "./ProfileEdit.vue?vue&type=style&index=0&id=a5993552&scoped=true&lang=less&"
import style1 from "./ProfileEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5993552",
  null
  
)

export default component.exports